import DOMPurify from 'dompurify';

export function sanitizeHtml(input: string): string {
  if (!input) return '';
  return DOMPurify.sanitize(input, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['svg', 'math'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  });
}

export function sanitizeSvg(input: string): string {
  if (!input) return '';

  return DOMPurify.sanitize(input, {
    USE_PROFILES: { svg: true, svgFilters: true }, // allow filters and gradients
    ADD_TAGS: ['foreignObject', 'style', 'use', 'marker', 'pattern', 'linearGradient', 'radialGradient'],
    ADD_ATTR: [
      'class',
      'style',
      'transform',
      'xlink:href',
      'href',
      'marker-start',
      'marker-mid',
      'marker-end',
      'viewBox',
      'preserveAspectRatio'
    ],
    FORBID_TAGS: ['script'], // keep this forbidden
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  });
}
